import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ScanItem {
  scan_uuid: string | number;
  onprem_posture_id?: string;
  name: string;
  selectedname?: string;
}


interface InitialState {
  ScanDetails: ScanItem[];
  selectedname: string;
  scan_uuid: string;
  edit: boolean;
  status: string;
  scanTime: string;
  scanType: string;
  myscanSocketData: any[]; // Add this
  myscanStatusList: any[]; // Add this
  reportDetails?: any;
  deletedReportId?:any; 
  onprem_posture_id?: string;
}

const initialState: InitialState = {
  ScanDetails: [],
  selectedname: "",
  scan_uuid: "",
  edit: false,
  status:"",
  scanTime:"",
  scanType: "",
  myscanSocketData: [], // Initialize here
  myscanStatusList: [], // Initialize here
  reportDetails: null, // Initialize reportDetails
  deletedReportId:null,
  onprem_posture_id: "",
};

const MyScanTable_Details_slice = createSlice({
  name: "ScanDetails",
  initialState,
  reducers: {
    setScanDetails: (state, action: PayloadAction<ScanItem[]>) => {
      state.ScanDetails = action.payload;
    },
    setSelectedName: (state, action: PayloadAction<string>) => {
      state.selectedname = action.payload;
    },
    setEdit: (state, action: PayloadAction<{ edit: boolean; scan_uuid: string,status:string,scanTime:string, scanType?: string, onprem_posture_id?: string }>) => {
      state.edit = action.payload.edit;
      state.scan_uuid = action.payload.scan_uuid;
      state.status = action.payload.status || ""; // Optional status field
      state.scanTime = action.payload.scanTime || ""; // Optional scanTime field
      state.scanType = action.payload.scanType || ""; // Optional scanType field
      state.onprem_posture_id = action.payload.onprem_posture_id || ""; 
    },
    setMyScanSocketData: (state, action: PayloadAction<any[]>) => {
      state.myscanSocketData = action.payload;
    },
    setMyScanStatusList: (state, action: PayloadAction<any[]>) => {
      state.myscanStatusList = action.payload;
    },
    setReportDetails: (state, action) => {
      state.reportDetails = action.payload;
    },
    setDeletedReportId:(state,action)=>{
      state.deletedReportId = action.payload
    }
  },
});

export const { setScanDetails, setSelectedName, setEdit, setMyScanSocketData,setMyScanStatusList,setReportDetails,setDeletedReportId } = MyScanTable_Details_slice.actions;
export default MyScanTable_Details_slice.reducer;
